// extracted by mini-css-extract-plugin
module.exports = {"actions":"_aa68a9","closeIcon":"_cde4ee","closeIconButton":"_6564ae","content":"_beff58","title":"_67b0fa"};